import { Options } from '../entities';
import * as yup from 'yup';

export const schemaOptions = yup.object<Partial<Options>>({
    name: yup.string().required(),
    description: yup.string().nullable(),
    texte: yup.string().nullable(),
});
